/**
 * MFA (TOTP) account-security client. Backs the Settings › Security card.
 * All endpoints require the current session cookie (set by /auth/login).
 *
 *   GET  /v1/auth/mfa/status        → { enabled, enrolling }
 *   POST /v1/auth/mfa/enroll        → { secret, otpauth_uri }   (pending)
 *   POST /v1/auth/mfa/enroll/verify → { enabled }               (activates)
 *   POST /v1/auth/mfa/disable       → { enabled }
 */
import { apiGet, apiPost } from '@/api/client';

export interface MfaStatus {
  enabled: boolean;
  enrolling: boolean;
}

export interface MfaEnrollResult {
  secret: string;
  otpauth_uri: string;
}

export function getMfaStatus(signal?: AbortSignal): Promise<MfaStatus> {
  return apiGet<MfaStatus>('/v1/auth/mfa/status', signal ? { signal } : undefined);
}

export function beginMfaEnroll(): Promise<MfaEnrollResult> {
  return apiPost<MfaEnrollResult>('/v1/auth/mfa/enroll');
}

export function confirmMfaEnroll(code: string): Promise<{ enabled: boolean }> {
  return apiPost<{ enabled: boolean }>('/v1/auth/mfa/enroll/verify', { code });
}

export function disableMfa(code: string): Promise<{ enabled: boolean }> {
  return apiPost<{ enabled: boolean }>('/v1/auth/mfa/disable', { code });
}
